enum TextButtonTheme {
  Navy = "Navy",
  Primary = "Primary",
  PurpleGradient = "PurpleGradient",
  Secondary = "Secondary",
  White = "White",
}

export default TextButtonTheme;
